/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Toast_Archive_FailedInputs */



/**
* | output |
* | --- |
* | "Could not change the archive state. Please try again." |
*
* @param {Spaces_Toast_Archive_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_toast_archive_failed = /** @type {((inputs?: Spaces_Toast_Archive_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Toast_Archive_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Archivierungsstatus konnte nicht geändert werden. Bitte versuchen Sie es erneut.")
	return /** @type {LocalizedString} */ ("Could not change the archive state. Please try again.")
});